import $ from 'jquery'

export default {
    name: 'cancel-invoice',
    components: {},
    props: {
        selected_invoice: Object,
        is_facture_assurance: Number
    },
    data() {
        return {
            save_loading: false,
            is_confirm: false,
        }
    },

    computed: {

    },

    mounted() {

    },

    methods: {
        /**
         * Cache le message d'erreur au click du checkbox
         */
        onConfirm() {
            $('.err-msg').fadeOut(500);
        },

        confirmer() {
            this.is_confirm = true
        },

        delInvoice(selector) {
            let confirm = document.getElementById(selector);

            if (confirm.checked == false) { 
                $('.err-msg').fadeIn(500)
                this.save_loading = false
                return
            }

            this.save_loading = true

            let dispatch_action = (this.is_facture_assurance == 0)?'cancelInvoice':'cancelPayBackInvoice'
            this.$store.dispatch(dispatch_action, this.selected_invoice).then((response) => {
                if (response.success) {
                    this.$emit((this.is_facture_assurance == 0)?'emitFacture':'emitAssurFacture')

                    if (this.is_facture_assurance == 0) {
                        this.$refs.cancel_invoice.click();
                    } else {
                        this.$refs.cancel_pay_back_invoice.click();
                    }
                    
                    this.successToast("Facture annulée avec succès")
                } else {
                    if (response.code == 400) {
                        this.dangerToast("Merci de raffraîchir la page puis réessayer !")
                    }
                }
                this.save_loading = false
            }).catch(() => {
                this.warningToast("Une erreur s'est produite ! Merci de raffraîchir la page puis réessayer.")
                this.save_loading = false
            })
        }
    }
}